import { graphql } from '@apollo/client/react/hoc'

import { getBrandConnectedAccounts } from 'utils/transformations/accounts'

import { graphene } from 'graphql/tags'

export const MINIMUM_CHARACTERS_QUERY = 2

// TODO(ch44742) Sustainable way (w/o repetition) for connectedAccounts query
const copyOrderQuery = graphene`#graphql
  query CopyOrderQuery($searchFilter: String) {
    connectedAccounts(filterBy: { displayName: $searchFilter }) {
      edges {
        node {
          ... on RetailerAccount {
            id
            displayName
            locations(filterBy: { primary: true }) {
              edges {
                node {
                  id
                  state
                  city
                }
              }
            }
          }
        }
      }
    }
  }
`

export const connectedRetailersData = ({
  data: { connectedAccounts, loading, error },
}) => ({
  retailers:
    !loading && !error && connectedAccounts
      ? getBrandConnectedAccounts(connectedAccounts)
      : [],
  connectedAccountsQueryLoading: loading,
})

export const withConnectedRetailers = graphql(copyOrderQuery, {
  options: ({ retailerSearchText }) => ({
    variables: { searchFilter: retailerSearchText },
  }),
  props: connectedRetailersData,
  skip: ({ retailerSearchText }) =>
    retailerSearchText.length < MINIMUM_CHARACTERS_QUERY,
})
